import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import RiskTemplateField from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/RiskTemplateField'
// types
import { Forms } from 'constants/forms'
import { IField } from 'types/graphql'
// views
import { FieldsWrapper, Form } from './views'

interface Props {
  fields: IField[]
  onFieldUpdate: any
}

const RiskFieldsForm: React.FC<InjectedFormProps<Record<string, any>, Props> & Props> = ({
  fields = [],
  handleSubmit,
  onFieldUpdate
}) => (
  <Form onSubmit={handleSubmit}>
    <FieldsWrapper>
      {fields.map((field) => (
        <RiskTemplateField key={field.id} field={field} onFieldUpdate={onFieldUpdate} />
      ))}
    </FieldsWrapper>
  </Form>
)

export default reduxForm<Record<string, any>, Props>({
  form: Forms.RISK_TEMPLATE_FORM,
  enableReinitialize: true,
  destroyOnUnmount: true
})(RiskFieldsForm)
